import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface Toast {
  id: string;
  fromDisplay: string;
  notificationType: string;
  message: string;
  timestamp: Date;
}

/**
 * Manages a FIFO queue of top-right toast notifications.
 * Does NOT modify any application state — purely visual queuing.
 */
@Injectable({ providedIn: 'root' })
export class ToastQueueService {
  private readonly toastsSubject = new BehaviorSubject<Toast[]>([]);

  public readonly toasts$: Observable<Toast[]> = this.toastsSubject.asObservable();

  push(toast: Omit<Toast, 'id'>): void {
    const id = `t-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
    // Newest at the top of the stack
    this.toastsSubject.next([{ id, ...toast }, ...this.toastsSubject.value]);
  }

  dismiss(id: string): void {
    this.toastsSubject.next(this.toastsSubject.value.filter(t => t.id !== id));
  }

  dismissAll(): void {
    this.toastsSubject.next([]);
  }
}
